// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"cfd9b146","453":"7d39ade3","977":"ee0b8a0d"}[chunkId] + ".chunk.js";
};